import React, { createContext, useContext, useMemo } from "react";
import { getV2Tokens, V2_THEME } from "./tokens";

const ThemeContext = createContext({
  skin: V2_THEME,
  setSkin: () => {},
  tokens: getV2Tokens(V2_THEME),
});

export function V2ThemeProvider({ children }) {
  const skin = V2_THEME;
  const setSkin = () => {};

  const value = useMemo(
    () => ({
      skin,
      setSkin,
      tokens: getV2Tokens(skin),
    }),
    [skin]
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useV2Theme() {
  return useContext(ThemeContext);
}
